import React from 'react';
import { Box } from '@mui/material';
import {
  ExpandFiltersButton,
  ExportButton,
  ExportButtonProps,
  ResetFiltersButton
} from './filterActionButtons';

export type ActionButtonsProps = {
  hasActiveFilters: boolean;
  onReset: () => void;
  regularFiltersLength: number;
  expanded: boolean;
  onToggle: () => void;
} & ExportButtonProps;

export const ActionButtons = ({
  hasActiveFilters,
  onReset,
  regularFiltersLength,
  expanded,
  onToggle,
  exportConfig,
  onExcelClick,
  openExcel,
  exportDisabled,
  loading,
  anchorEl,
  exportMenuItems,
  onMenuItemClick,
  onCloseMenu
}: ActionButtonsProps) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      <ResetFiltersButton hasActiveFilters={hasActiveFilters} onReset={onReset} />
      <ExpandFiltersButton regularFiltersLength={regularFiltersLength} expanded={expanded} onToggle={onToggle} />
      <ExportButton
        exportConfig={exportConfig}
        onExcelClick={onExcelClick}
        openExcel={openExcel}
        exportDisabled={exportDisabled}
        loading={loading}
        anchorEl={anchorEl}
        exportMenuItems={exportMenuItems}
        onMenuItemClick={onMenuItemClick}
        onCloseMenu={onCloseMenu}
      />
    </Box>
  );
};
